import { getCookie } from '../utils/cookie';

import request, { apiURL } from '../utils/api';
class ReferralTypeService {
  getAll() {
    const options = {
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
    };
    return request(`${apiURL}/referralTypes`, options);
  }
}

export default ReferralTypeService;
